import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "eco-actions border-bottom border-1 mt-3 pt-2 mb-4" }
const _hoisted_2 = { class: "fw-bold body-strong" }
const _hoisted_3 = { class: "row row-cols-1 row-cols-md-2 g-3 mt-3 mb-3" }
const _hoisted_4 = {
  class: "rounded-circle d-flex align-items-center justify-content-center",
  style: {"width":"40px","height":"40px","background-color":"var(--green-200)","flex-shrink":"0"}
}
const _hoisted_5 = {
  width: "24",
  height: "24",
  class: "icon",
  color: "var(--primary-green)"
}
const _hoisted_6 = ["xlink:href"]
const _hoisted_7 = { class: "m-0 body" }

import { computed } from 'vue';

// Define props
interface Props {
  isCriteriaFloconVert: boolean;
  isCriteriaCleVerte: boolean;
}
interface EcoAction {
  icon: string;
  text: string;
  key: string;
}

// Define all possible actions with their corresponding icons and text

export default /*@__PURE__*/_defineComponent({
  __name: 'EcoActions',
  props: {
    isCriteriaFloconVert: { type: Boolean },
    isCriteriaCleVerte: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

// Access the global content object
const content = window.content as { [key: string]: string };

// Compute the eco actions title based on the criteria
const ecoActionsTitle = computed<string>(() => {
  if (props.isCriteriaFloconVert && props.isCriteriaCleVerte) {
    return content.eco_responsible_commitments_actions_title_if_both_labels;
  } else if (props.isCriteriaCleVerte) {
    return content.eco_responsible_commitments_actions_title_if_cleverte_label;
  } else if (props.isCriteriaFloconVert) {
    return content.eco_responsible_commitments_actions_title_if_floconvert_label;
  }
  return '';
});

// Define interface for actions
const allActions = computed<EcoAction[]>(() => [
  {
    icon: '#___icon___responsible',
    text: content.eco_responsible_commitments_save_water_action,
    key: 'save_water',
  },
  {
    icon: '#___icon___localisation',
    text: content.eco_responsible_commitments_sustainable_activities_action,
    key: 'sustainable_activities',
  },
  {
    icon: '#___icon___temperature',
    text: content.eco_responsible_commitments_foot_print_action,
    key: 'foot_print',
  },
  {
    icon: '#___icon___spray',
    text: content.eco_responsible_commitments_responsible_cleaning_action,
    key: 'responsible_cleaning',
  },
  {
    icon: '#___icon___recycle',
    text: content.eco_responsible_commitments_waste_reduction_action,
    key: 'waste_reduction',
  },
  {
    icon: '#___icon___electricity',
    text: content.eco_responsible_commitments_low_electiricity_consumption_action,
    key: 'low_electricity_consumption',
  },
]);

// Compute the filtered actions based on the criteria
const filteredActions = computed<EcoAction[]>(() => {
  if (props.isCriteriaFloconVert && !props.isCriteriaCleVerte) {
    return allActions.value.filter(action =>
      !['responsible_cleaning', 'low_electricity_consumption'].includes(action.key)
    );
  }
  return allActions.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(ecoActionsTitle.value), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredActions.value, (action) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col d-flex align-items-center gap-3",
          key: action.key
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock("svg", _hoisted_5, [
              _createElementVNode("use", {
                "xlink:href": action.icon
              }, null, 8, _hoisted_6)
            ]))
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(action.text), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})